import Vue from "vue";
import moment from "moment";
import { Component, Prop } from "vue-property-decorator";
import { AbsenceSalarieDto } from "../../../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { EtatAbsencesEnum } from "../../../../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { ParametresInstance } from "../../../../../Controls/Parameters";
import DataTestIDHelper from "../../../../../../Helper/DataTestID/DataTestIDHelper";

@Component
export default class TableauDemandeTerminee extends Vue {
	@Prop()
	public absencesDemandeTerminee: AbsenceSalarieDto[] = [];

	public afficherModalSupprimerAbsence(absence: AbsenceSalarieDto, estValide: boolean, annulerAnnulation: boolean): void {
    	this.$emit("afficherModalSupprimerAbsence", { absence, estValide, annulerAnnulation });
	}

	public demanderAnnulationAbsenceSalarie(absence: AbsenceSalarieDto): void {
    	this.$emit("demanderAnnulationAbsence", absence);
	}

	public estAnnulable(absence: AbsenceSalarieDto): boolean {
    	if (this.estRefuse(absence)) {
    		return false;
    	}

    	const dateNow = moment.utc().startOf("day").unix();
    	const dateDebut = moment.utc(absence.DateDebut).unix();

    	return (dateNow < dateDebut);
	}

	public estValideOuPlus(absence: AbsenceSalarieDto): boolean {
    	return absence.Etat == EtatAbsencesEnum.Valide ||
            absence.Etat == EtatAbsencesEnum.Calcule ||
            absence.Etat == EtatAbsencesEnum.Cloture;
	}

	public estRefuse(absence: AbsenceSalarieDto): boolean {
    	return absence.Etat == EtatAbsencesEnum.Refuse;
	}

	public estCommentaireAccessible(absence: AbsenceSalarieDto): boolean {
    	return (absence.CommentaireManager != undefined && absence.CommentaireManager.length > 0 &&
            (absence.Etat == EtatAbsencesEnum.Refuse || absence.Etat == EtatAbsencesEnum.Valide));
	}

	public getLibelleEtat(absence: AbsenceSalarieDto): string {
    	let libelleEtat = ParametresInstance.getLibelleEtatAbsence(absence.Etat);
    	libelleEtat = libelleEtat[0].toUpperCase() + libelleEtat.slice(1);

    	if ((absence.Etat === EtatAbsencesEnum.Valide ||
            absence.Etat === EtatAbsencesEnum.Annule ||
            absence.Etat === EtatAbsencesEnum.Refuse) &&
            absence.DateValidation != undefined) {
			libelleEtat = libelleEtat + " le " + moment(absence.DateValidation).format("DD/MM/YYYY");
		}

    	return libelleEtat;
	}

	public afficherModalDetailAbsence(absence: AbsenceSalarieDto): void {
    	this.$emit("afficherModalDetailAbsence", { absence });
    }

    public getAbsenceRequestEntryDataTestID(absence: AbsenceSalarieDto, suffix: string): string {
        return DataTestIDHelper.getAbsenceRequestDataTestID(absence.LibelleTypeAbsence, absence.DateDebut, absence.DateFin, "salarie-pastRequestsList-", suffix);
    }
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/listeDesDemandes/espaceSalarie/tableaux/tableauDemandeTerminee/tableauDemandeTerminee.ts